/** Decode common HTML entities after tag stripping (e.g. Quill `&nbsp;` → space). */
function decodeHtmlEntities(text: string): string {
  if (!text) {
    return '';
  }
  if (typeof document !== 'undefined') {
    const el = document.createElement('textarea');
    el.innerHTML = text;
    return el.value;
  }
  return text
    .replace(/&nbsp;/gi, ' ')
    .replace(/&amp;/gi, '&')
    .replace(/&lt;/gi, '<')
    .replace(/&gt;/gi, '>')
    .replace(/&quot;/gi, '"')
    .replace(/&#39;/gi, "'")
    .replace(/&#(\d+);/g, (_, code) => String.fromCharCode(Number(code)))
    .replace(/&#x([0-9a-f]+);/gi, (_, hex) => String.fromCharCode(parseInt(hex, 16)));
}

/** Remove script/style tags but keep rich-text HTML for safe display (e.g. Quill output). */
export function sanitizeRichHtmlForDisplay(value: string | undefined | null): string {
  if (value == null || typeof value !== 'string') {
    return '';
  }
  return value
    .replace(/<script\b[^<]*(?:(?!<\/script>)<[^<]*)*<\/script>/gi, '')
    .replace(/<style\b[^<]*(?:(?!<\/style>)<[^<]*)*<\/style>/gi, '')
    .trim();
}

/** Strip rich-text HTML and return plain text for display or API payloads. */
export function stripRichTextToPlainText(value: string | undefined | null): string {
  if (value == null || typeof value !== 'string') {
    return '';
  }
  let s = value.replace(/<script\b[^<]*(?:(?!<\/script>)<[^<]*)*<\/script>/gi, ' ');
  s = s.replace(/<style\b[^<]*(?:(?!<\/style>)<[^<]*)*<\/style>/gi, ' ');
  s = s.replace(/<[^>]+>/g, ' ');
  s = decodeHtmlEntities(s);
  return s.replace(/\s+/g, ' ').trim();
}
